import { render } from "./HistoricFundPrices.vue?vue&type=template&id=48e4402b"
import script from "./HistoricFundPrices.vue?vue&type=script&lang=js"
export * from "./HistoricFundPrices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__